export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  // {
  //   field: 'col-opt',
  //   title: '操作',
  //   headerAlign: 'center',
  //   align: 'left',
  //   fixed: 'left',
  //   width: 80,
  //   slots: {
  //     default: 'opt'
  //   }
  // },
  {
    field: 'waybillNo',
    title: '运单编号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'wayBillStatusName',
    title: '运单状态',
    headerAlign: 'center',
    align: 'center',
    width: 80
  },
  // {
  //   field: 'bizStatusName',
  //   title: '业务状态',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  {
    field: 'carrierName',
    title: '承运商',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    field: 'transportModeName',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  // {
  //   field: 'contractCarrierName',
  //   title: '合同名称',
  //   headerAlign: 'center',
  //   align: 'left',
  //   width: 120,
  //   showHeaderOverflow: 'title',
  //   showOverflow: true
  // },
  // {
  //   field: 'payAmount',
  //   title: '支出运费',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'payFeeAmount',
  //   title: '支出费用',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'payTotalAmount',
  //   title: '支出总价',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'contractFreightAmount',
  //   title: '合同运费',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'contractFeeAmount',
  //   title: '合同费用',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'contractAmount',
  //   title: '合同支出',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  {
    field: 'totQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totPayWeight',
    title: '支出总重量',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totPayVolume',
    title: '支出总体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totValue',
    title: '总货值',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleModelName',
    title: '车型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleLengthName',
    title: '车长',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleLoad',
    title: '载重',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleVolume',
    title: '载方',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createByName',
    title: '创建人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createTime',
    title: '创建时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyByName',
    title: '修改人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
